import Vue from 'vue'
import Vuex from 'vuex'

import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex)

const state = {
  isLoggedIn: false,
  userName: '',
  token: '',
  error: '',
  projectVersion: process.env.VUE_APP_VERSION || '0'
}

export default new Vuex.Store({
  state,
  mutations,
  actions
})
